module.exports = __webpack_public_path__ + "static/media/vip.4e7b68e5.png";